import '@software-platforms/design-system-styles';
import cx from 'classnames';
import React from 'react';
import './pki-combobox.scss';

export type PkiComboBoxOptionProps = {
  className?: string;
  disabled?: boolean;
  group?: string;
  value: any;
  icon?: React.ReactNode;
  iconSize?: string;
  [key: string]: any;
};

export const PkiComboBoxOption: React.FunctionComponent<React.PropsWithChildren<PkiComboBoxOptionProps>> = (props) => {
  const { children, className, group, icon, iconSize, value, ...rest } = props;

  let height;
  let width;
  if (iconSize) {
    const parts = iconSize.split(' ');
    height = parts[0];
    width = parts?.length > 1 ? parts[1] : parts[0];
  }

  return (
    <div
      className={cx('pki-combobox-option', className, { selected: rest['aria-selected'] })}
      data-group={group}
      data-value={value}
      {...rest}
    >
      {icon ? (
        <span className="pki-combobox-option-icon" style={{ height, width }}>
          {icon}
        </span>
      ) : null}
      {children}
    </div>
  );
};
PkiComboBoxOption.displayName = 'PkiComboBoxOption';
